var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Field from "../Field/Field";
import { Controller } from "react-hook-form";
import CreatableSelect from "react-select/creatable";
var colorRed500 = "rgb(239, 68, 68)";
var colorBlue500 = "#3b82f6";
var colorBlue600 = "#2563eb";
var colorGray100 = "#f3f4f6";
var colorGray300 = "rgb(209, 213, 219)";
var InputCreatableSelect = function (_a) {
    var id = _a.id, displayName = _a.displayName, nameHookForm = _a.nameHookForm, options = _a.options, error = _a.error, rules = _a.rules, disabled = _a.disabled, tip = _a.tip, control = _a.control, isValidNewOption = _a.isValidNewOption, formatCreateLabel = _a.formatCreateLabel, placeholder = _a.placeholder, defaultValue = _a.defaultValue;
    var customStyles = {
        control: (function (styles, _a) {
            var isFocused = _a.isFocused, menuIsOpen = _a.menuIsOpen;
            var isActive = isFocused || menuIsOpen;
            var isError = error !== undefined;
            var borderColor = disabled
                ? "#e5e7eb"
                : (isError ? colorRed500 : (isActive ? colorBlue500 : colorGray300));
            var boxShadow = isActive
                ? "0 0 0 0 #ffff, 0 0 0 1px ".concat(isError ? colorRed500 : colorBlue500, ", 0 0 #000")
                : "0";
            return __assign(__assign({}, styles), { "fontSize": "0.875rem", "backgroundColor": disabled ? "#f9fafb" : "#ffffff", "borderColor": borderColor, "borderRadius": "0.375rem", "boxShadow": boxShadow, "&:hover": {
                    "boxShadow": boxShadow,
                    "borderColor": borderColor
                } });
        }),
        option: (function (styles, _a) {
            var isSelected = _a.isSelected;
            var backgroundColor = isSelected ? colorBlue600 : "transparent";
            var color = isSelected ? "#ffffff" : "#000000";
            return __assign(__assign({}, styles), { color: color, "backgroundColor": backgroundColor, "fontSize": "0.875rem", "&:hover": {
                    "backgroundColor": isSelected ? backgroundColor : colorGray100
                } });
        }),
        input: (function (styles) {
            return __assign(__assign({}, styles), { "input:focus": {
                    boxShadow: "none",
                } });
        }),
        menu: function (base) { return (__assign(__assign({}, base), { zIndex: 40 })); }
    };
    var inputEl = (_jsx(Controller, { name: nameHookForm, control: control, rules: rules, render: function (_a) {
            var field = _a.field;
            return _jsx(CreatableSelect, __assign({ classNamePrefix: "react-select", isDisabled: disabled, styles: customStyles, isSearchable: true, options: options, isValidNewOption: isValidNewOption, formatCreateLabel: formatCreateLabel, placeholder: placeholder, defaultValue: defaultValue }, field));
        } }));
    return (_jsx(Field, { inputEl: inputEl, id: id, displayName: displayName, error: error, tip: tip, exclamationPadding: "pr-12" }));
};
export default InputCreatableSelect;
